import { render } from "./authcomponent.vue?vue&type=template&id=549535a0"
import script from "./authcomponent.vue?vue&type=script&lang=js"
export * from "./authcomponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__